import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AtivarContaDTO } from 'src/app/entity/AtivarContaDTO';
import { AuthService } from 'src/app/service/autenticacao/auth.service';
import { PAGINA_LOGIN } from 'src/app/tools/URL';

@Component({
  selector: 'ativar-conta',
  templateUrl: './ativar-conta.component.html',
  styleUrls: ['./ativar-conta.component.css']
})
export class AtivarContaComponent implements OnInit {

  urlLogin = PAGINA_LOGIN;
  ativarContaDTO = new AtivarContaDTO();

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {}

ngOnInit() {
  this.activatedRoute.queryParamMap
    .subscribe(params => {
      this.ativarContaDTO.idUsuario = params.get('query');
    });
}

ativar() {

    this.authService.ativarConta(this.ativarContaDTO);

  }


}
